
import { FC } from "react";

const Feedback: FC = () => {
    return (
        <>
            <iframe className="full-screen-iframe"
                src="https://forms.office.com/Pages/ResponsePage.aspx?id=2270kNJ7m0OeVycOpdijtd2f4DD6o-dKvOAJeR2THARURVM5R1dRTVVTOEMxVFVQNk5WRlQzWEc1Ny4u&embed=true"
                // border="0"
                // width="0"
                // marginheight="0"
                style={{
                    border: "none",
                    width: "100%",
                    height: "100%"
                }}
                allowFullScreen
            />

        </>
    )
}
export default Feedback;